if ($('#app-form-post-centro-edit').length) {

    show_loader();

    $('#advertiser').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });
    $('#campaign').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 5
    });

    $('#advertiser').on('change', function () {
        $('#campaign').html('');
        var adv_id = $('#advertiser option:selected').val();
        if (typeof adv_id !== 'undefined' && adv_id !== '') {
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/post/centro/getCampaigns/' + adv_id,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    var html = '<option></option>';
                    for (var i in data)
                        html += '<option value="' + data[i].id + '">' + data[i].name + '</option>';
                    $('#campaign').html(html);
                    $('#form_submit').attr("disabled", 'disabled');
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });

    $('#campaign').on('change', function () {
        $('#form_submit').attr("disabled", false);
        $('#centro_start').val('');
        $('#centro_end').val('');
        var camp_id = $('#campaign option:selected').val();
        console.log('camp_id', camp_id);
        if (typeof camp_id !== 'undefined' && camp_id !== '') {
            show_loader();
            $.ajax({
                type: 'GET',
                url: '/post/centro/flightdates/' + camp_id,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    console.log('data', data);
                    $('#centro_start').val(data['start']);
                    $('#centro_end').val(data['end']);
                    hide_loader();
                },
                error: function (xhr) {
                    hide_loader();
                    ajax_error();
                    debug(xhr.responseText);
                }
            });
        }
    });

    $('#post_buy_options').multiSelect({
        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
        selectionHeader: "<div class='' style='height: 38px;'> </div>",
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                .on('keydown', function(e){
                    if (e.which === 40){
                        that.$selectableUl.focus();
                        return false;
                    }
                });
        },
        afterSelect: function(values){
            this.qs1.cache();
        },
        afterDeselect: function(values){
            this.qs1.cache();
        }
    });

    $('#post_buy_stats').multiSelect({
        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
        selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-10 btn-sm select_all_columns' id='select_all_columns'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='deselect_all_columns'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div></div>",
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                .on('keydown', function(e){
                    if (e.which === 40){
                        that.$selectableUl.focus();
                        return false;
                    }
                });
        },
        afterSelect: function(values){
            this.qs1.cache();
        },
        afterDeselect: function(values){
            this.qs1.cache();
        }
    });

    $('#deselect_all_columns').on('click', function(e){
        $('#post_buy_stats').multiSelect('deselect_all');
    });
    $('#select_all_columns').on('click', function(e){
        $('#post_buy_stats').multiSelect('select_all');
    });
    $('#post_buy_stats').html( $('#post_buy_stats option').sort(function(x, y) {
        return $(x).text() < $(y).text() ? -1 : 1;
    })).multiSelect('refresh');

    $('#form_submit').attr("disabled", false);
    hide_loader();

    $('#form_submit').on('click', function () {
        var options = $('#post_buy_options option:selected').length;
        if (options > 0) {
            console.log($('#post_buy_options option:selected'));
            var stats = $('#post_buy_stats option:selected').length;
            if (stats > 0) {
                console.log($('#post_buy_stats option:selected'));
                var name = $('#post_report_name').val();
                if(name.trim() === "")
                    global_notification('warning', 'Please complete report\'s name ...');
                else if($('#centro_start').val() > $('#centro_end').val() || $('#centro_start').val() === "" || $('#centro_end').val() === "") {
                    global_notification('warning', 'Invalid flight dates range ...');
                }else{
                    show_loader();
                    $('#app-form-post-centro-edit').submit();
                }
            } else
                global_notification('warning', 'Please select at least one report option ...');
        } else
            global_notification('warning', 'Please select at least one analysis breakout ...');

    });

}
